import React from 'react';

import Button from '../UI/Button/Button';

import './SubProjectButton.scss'


const SubProjectButton = props => {
  const {project, isProjectDisabled, onClick, selectedProject} = props

  return (
    <Button
      btnId={project.projectId}
      key={project.projectId}
      disabled={isProjectDisabled}
      onClick={isProjectDisabled ? () => {} : () => {onClick(project)}}
      className={`sub-project-button ${selectedProject?.projectName == project.projectName ? 'selected-project' : ''}`}
    >
      <div className="request-button-container">
        <label>{project.projectName}</label>
      </div>
    </Button>
  );
};

export default SubProjectButton;
